import React from 'react'
import clsx from 'clsx';
import { ReactComponent as IconClose } from 'images/close.svg';
import Button from '../Button';
import styles from './CloseBtn.module.scss';

type CloseBtnProps = {
  className?: string,
  onClick?: () => void,
  grey?: boolean,
}

function CloseBtn({
  className = '',
  onClick = () => { },
  grey = false,
}: CloseBtnProps) {
  if (grey) {
    return (
      <Button
        className={className}
        onClick={onClick}
        iconBtn
      >
        <IconClose />
      </Button>
    )
  }

  return (
    <button
      type="button"
      className={clsx(styles.btnClose, className)}
      onClick={onClick}
    />
  )
}

export default CloseBtn
